import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      // Cookie is set httpOnly by the backend — we only need to remember the user profile
      // for greeting the host on the dashboard. No JWT in localStorage.
      sessionStorage.setItem("staytlv_admin_user", JSON.stringify(r.data.user));
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-6 py-20">
      <p className="overline mb-3">{t("admin.login_title")}</p>
      <h1 className="font-serif text-4xl text-[#2C2A29]">{t("admin.login_title")}</h1>
      <p className="text-[#595450] mt-2">{t("admin.login_sub")}</p>

      <form onSubmit={submit} className="mt-10 space-y-6 bg-white border border-[#EAE3D9] rounded-2xl p-8">
        <label className="block">
          <span className="text-xs uppercase tracking-wider text-[#8C7A6B]">{t("admin.email")}</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                 data-testid="admin-email-input" className="input-line" />
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-wider text-[#8C7A6B]">{t("admin.password")}</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                 data-testid="admin-password-input" className="input-line" />
        </label>
        <button type="submit" disabled={busy} data-testid="admin-login-btn"
                className="btn-primary w-full disabled:opacity-50">{busy ? "..." : t("admin.login")}</button>
      </form>

      <div className="flex items-center gap-4 my-6">
        <div className="flex-1 h-px bg-[#EAE3D9]" />
        <span className="text-xs text-[#8C7A6B]">or</span>
        <div className="flex-1 h-px bg-[#EAE3D9]" />
      </div>

      <button onClick={googleLogin} data-testid="admin-google-btn"
              className="btn-secondary w-full inline-flex items-center justify-center gap-2">
        <svg className="h-4 w-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.46 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38z"/></svg>
        {t("admin.google")}
      </button>
    </div>
  );
}
